import { createReducer, on } from "@ngrx/store";
import { ThirdPartySettings, ThirdPartyState } from "../third-party.state";
import { openAiLinkActions } from "./open-ai-link.actions";

export const initialState: ThirdPartySettings = {
    isLinked: false,
    isAccountKey: false
}

export const openAiLinkReducer = createReducer<ThirdPartyState['openAiSettings']>(
    initialState,
    on(openAiLinkActions.load, (_state, { settings }) => {
        return settings;
    }),
    on(openAiLinkActions.loaded, (_state, { settings }) => {
        return settings;
    })
);

